<template>
  <div
    :class="[
      $style.tariff_card,
      planData.name,
      isPopup ? $style.popup_item : $style.page_item,
      isEnterprise ? $style.enterprise : null,
      (!isAnnual && isEnterprise) || (isAnnual && isEnterprise && teamSize.count === 1) ? $style.disabled : null,
    ]"
  >
    <div :class="$style.title">
      <div
        :class="$style.plan_name"
        :style="{textTransform: 'capitalize'}"
      >
        {{ planData.plan_name }}
      </div>
      <!--      <div-->
      <!--        v-if="isEnterprise"-->
      <!--        :class="$style.chip"-->
      <!--      >-->
      <!--        {{ locales('tariff_card_enterprise_chip') }}-->
      <!--      </div>-->
    </div>
    <div :class="$style.description">
      {{ locales(`${planData.plan_title_locale}_plan_info_locale`) }}
    </div>
    <div :class="[$style.price, $style.action_box]">
      <div :class="$style.info">
        <div
          v-if="!isEnterprise && teamSize.count < 40"
          :class="$style.currency"
        >
          <span :class="$style.code">$</span>
          <span :class="$style.value">{{ `${planData.price}` }}</span>
          <span :class="$style.label">USD</span>
        </div>

        <div
          v-if="!isEnterprise && teamSize.count === 40"
          :class="$style.currency"
        >
          <span :class="$style.custom_non_interprice">{{ locales('pricing_custom_price_title') }}</span>
        </div>

        <div
          v-else-if="isEnterprise && teamSize.count < 40"
          :class="$style.currency"
        >
          <span :class="$style.code">$</span>
          <span
            v-if="isEnterprise"
            :class="[$style.value, $style.old_price]"
          >{{ +planData.price + 10 }}</span>
          <span
            v-if="isEnterprise"
            :class="$style.value"
          >{{ +planData.price }}</span>
          <span :class="$style.label">USD</span>
        </div>

        <div
          v-else-if="isEnterprise && teamSize.count === 40"
          :class="$style.currency"
        >
          <span :class="$style.custom">{{ locales('pricing_custom_price_title') }}</span>
        </div>

        <div :class="$style.description">
          {{ isAnnual ? `${locales('per_user_billed_annually_locale')}` : `${locales('per_user_locale')} ${locales('per_month_key')}` }}
        </div>
      </div>
      <tooltip
        v-if="(isShowBuyButton && isEnterprise && isAnnual && teamSize.count === 1) || (isShowBuyButton && isEnterprise && !isAnnual)"
        :content="locales(`pricing_custom_user_count_interprice`)"
        position="top"
      >
        <template #body>
          <div
            :class="[$style.btn, $style.upgrade_btn, !isAnnual ? $style.monthly_btn : null, isAnnual && teamSize.count === 1 ? $style.monthly_btn_disabled : null]"
            @click="isAnnual && teamSize.count === 1 ? null : onClickCardButton('buy', planData)"
          >
            {{ buttonText }}
          </div>
        </template>
      </tooltip>
      <div
        v-else-if="isShowBuyButton"
        :class="[$style.btn, $style.upgrade_btn, !isAnnual ? $style.monthly_btn : null]"
        @click="onClickCardButton('buy', planData)"
      >
        {{ buttonText }}
      </div>
      <div
        v-if="isShowUpgradeButton"
        :class="[$style.btn, $style.upgrade_btn, !isAnnual ? $style.monthly_btn : null]"
        @click="onClickCardButton('upgrade', planData)"
      >
        {{ buttonText }}
      </div>
      <div
        v-if="isShowCurrentTariffSticker"
        :class="[$style.current_plan_sticker, planData.name]"
      >
        <webix-ui
          :class="$style.plan_check_icon"
          :config="icons.check"
        />
        <div :class="$style.sticker_text">
          {{ locales('current_plan') }}
        </div>
      </div>
    </div>
    <div
      :class="$style.plan_features"
      :style="{height: `${heights.featuresSection}px`}"
    >
      <div
        ref="featuresDesc"
        :class="$style.features_desc"
        v-html="getPlanFeaturesListTitle(planData)"
      />
      <ul
        ref="featuresList"
        :class="$style.features_list"
      >
        <li :class="$style.item">
          {{ locales(`${planData.plan_title_locale}_feature_1`) }}
        </li>
        <li :class="$style.item">
          {{ locales(`${planData.plan_title_locale}_feature_2`) }}
        </li>
        <li :class="$style.item">
          {{ locales(`${planData.plan_title_locale}_feature_3`) }}
        </li>
        <li :class="$style.item">
          {{ locales(`${planData.plan_title_locale}_feature_4`) }}
        </li>
      </ul>
    </div>
    <div
      :class="[$style.about_plan_link, $style.link]"
      @click="onClickLearnMore(planData)"
    >
      {{ locales(`about_link_compare`) }}
      <svg
        width="20"
        height="12"
        viewBox="0 0 20 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14.5 1.5L19 6M19 6L14.5 10.5M19 6H1"
          stroke="#1565C0"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import svgIconForVue from '../../../common/svgIconForVue';
import app from '../../../../app';
import Tooltip from '$$vueCmp/tooltips/tooltip.vue';
import plansModel from '../../../../models/plans';

import bublesIcon from '../../../../svg/pricing/pricing_bubles_ic.svg';
import arrowLeft from '../../../../svg/pricing/ic_arrow_left.svg';
import peopleIcon from '../../../../svg/pricing/pricing_people_ic.svg';
import lockIcon from '../../../../svg/ic_lock.svg';
import check from '../../../../svg/pricing/check_current_plan_price.svg';
import globalStore from '../../../../store/main';

export default {
  name: 'TariffCard',
  components: { Tooltip },
  props: {
    planData: { type: Object, required: true, default: () => {} },
    isPopup: { type: Boolean, required: true, default: false },
    heights: { type: Object, required: true, default: () => {} },
    teamSize: { type: Object, required: true, default: () => {} },
    isAnnual: { type: Boolean, required: true, default: false },
  },
  emits: {
    buyPlanClick: Object,
    upgradePlanClick: Object,
    onClickLearnMore: null,
    switchToAnnual: null,
  },
  data() {
    return {
      locales: __,
      userCount: 1,
      icons: {
        bublesIcon: svgIconForVue(bublesIcon, 62, 49),
        arrowLeft: svgIconForVue(arrowLeft, 27, 16),
        peopleIcon: svgIconForVue(peopleIcon, 24, 24),
        lockIcon: svgIconForVue(lockIcon, 24, 24),
        check: svgIconForVue(check, 20, 20),
      },
    };
  },
  computed: {
    isTrial() {
      return plansModel.isTrial();
    },
    isEnterprise() {
      return this.planData.plan_name === 'enterprise';
    },
    buttonText() {
      if (this.isEnterprise) {
        if (this.isAnnual && this.teamSize.count !== 40) {
          return this.locales('bf_get_deal_enterprise_btn');
        }

        if (this.isAnnual && this.teamSize.count === 40) {
          return this.locales('btn_get_a_quote_locale');
        }

        return this.locales('pricing_plans_switch_annual');
      }

      if (this.teamSize.count !== 40) {
        return this.locales('upgrade_now_btn_locale');
      }

      if (this.teamSize.count === 40) {
        return this.locales('btn_get_a_quote_locale');
      }
    },
    isShowBuyButton() {
      return !this.isPopup || this.isTrial;
    },
    isShowUpgradeButton() {
      return this.isPopup && !this.planData.isCurrentPaymentPlan;
    },
    isShowCurrentTariffSticker() {
      return this.isPopup && this.planData.isCurrentPaymentPlan;
    },
  },
  methods: {
    getPlanFeaturesListTitle(planData) {
      let planName;

      if (planData && 'plan_id' in planData && 'plan_name' in planData) {
        if (planData.plan_id === 14) {
          return __('payment_plan_card_base_features_list_title');
        }

        if (planData.plan_id === 15) {
          planName = 'Core';
        }

        if (planData.plan_id === 16) {
          planName = 'Advanced';
        }

        if (planData.plan_id === 18) {
          planName = 'Business';
        }

        return __('payment_plan_card_features_list_title_by_plan_name', { planName });
      }

      return __(`${planData.plan_title_locale}_features_list_description`);
    },
    onClickLearnMore(data) {
      userExtAnalytics.log('pricing_learn_more_clicked', { type: data.name });
      if (this.isPopup) {
        window.open(this.locales(`about_plan_href_${data.plan_title_locale}`), '_blank');
      } else {
        this.$emit('onClickLearnMore');
      }
    },
    onClickCardButton(actionType, tariffData) {
      if (this.isEnterprise) {
        if (this.isAnnual) {
          // this.$emit('upgradePlanClick', tariffData);
          globalStore.dispatch('globalPopup/show', {
            type: 'contactUs',
            title: 'upgrade-via-sale-contact-us-form',
            width: 440,
            data: {
              name: tariffData.name,
            },
          });
          // #contactUs remove old version
          // app.trigger('messageUsForm:show', 'upgrade-via-sale-contact-us-form', tariffData.name);
        } else {
          this.$emit('switchToAnnual');
        }

        return;
      }

      if (actionType === 'buy' && this.teamSize.count !== 40) {
        this.$emit('buyPlanClick', tariffData);

        return;
      } if (actionType === 'buy' && this.teamSize.count === 40) {
        globalStore.dispatch('globalPopup/show', {
          type: 'contactUs',
          title: 'upgrade-via-sale-contact-us-form',
          width: 440,
          data: {
            name: tariffData.name,
          },
        });

        return;
      }

      if (actionType === 'upgrade' && this.teamSize.count !== 40) {
        this.$emit('upgradePlanClick', tariffData);
      } else if (actionType === 'upgrade' && this.teamSize.count === 40) {
        globalStore.dispatch('globalPopup/show', {
          type: 'contactUs',
          title: 'upgrade-via-sale-contact-us-form',
          width: 440,
          data: {
            name: tariffData.name,
          },
        });
      }
    },
  },
};
</script>

<style module lang="less">
@import '../../../../less/_mixins.less';
@import '../../../../less/_fonts.less';
@import '../../../../less/_variables.less';

@textColor: #424242;

.tooltip_label {
    width: 100%;
}

:global(.tooltip_label) {
    display: block;
    width: 100%;
}

.btn {
  width: 100%;
  text-align: center;
  .FontLatoBold;
  .fs(14px, 24px);
  background-color: #1565C0;
  border-radius: 4px;
  color: #FFFFFF;
  padding: 4px 0;
  cursor: pointer;
  white-space: nowrap;

  &:hover {
    color: #fff;
    background-color: #11519A;
    border-color: #11519A;
  }

  &:active{
    color: #fff;
    background-color: #0D3D73;
    border-color: #0D3D73;
  }
}

.tariff_card {
  // width: 252.5px;
  // min-width: 252px;
  border: 1px solid #D0E0F2;
  border-radius: 8px;
  padding: 16px;
  margin-right: 16px;
  min-height: 476px;

  min-width: calc(25% - 16px);
  width: calc(25% - 16px);

  &:last-child {
    margin-right: 0;
  }

  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;

    .plan_name {
      .FontLatoBlack;
      .fs(20px, 30px);
      color: @titleHeadColor;
    }

    .people_tooltip {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 0 3px;
      cursor: pointer;

      .count {
        .FontLatoRegular;
        .fs(16px, 30px);
        color: #666666;
        padding-left: 6px;
      }

      &:hover {
        .count {
          color: #1565C0;
        }
      }
    }

    .base_plan_tooltip {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      width: 30px;
      cursor: pointer;

      &:hover {
        background-color: #eee;
        border-radius: 1px;
      }
    }
  }

  .description {
    .FontLatoRegular;
    .fs(12px, 18px);
    color: #666666;
    height: 36px;
  }

  .title ~ .description {
    margin-bottom: 16px;
    min-height:72px;
  }

  .action_box {
    margin-bottom: 16px;
    .user-count-margin {
      margin-bottom: 0;
    }

    .panel {
      // min-height: 90px;
      height: 50px;
    }
  }

  .price {
    .info {
      // min-height: 85px;
      margin-bottom: 36px;
      .currency {
        color: #191919;

        .code {
          .FontLatoRegular;
          font-size: 20px;
          line-height: 1;
          vertical-align: top
        }

        .value {
          .FontLatoBlack;
          font-size: 32px;
          line-height: 38px;
          padding: 0 4px 0 2px;
        }

        .label {
          .FontLatoRegular;
          .fs(20px, 38px);
        }

          .custom {
              .FontLatoRegular;
              .fs(24px, 22px);
              color: #fff;
              min-height: 45px;
              display: inline-flex;
              align-items: center;
              margin-bottom: 5px;
          }

          .custom_non_interprice {
              .FontLatoRegular;
              .fs(24px, 22px);
              min-height: 45px;
              display: inline-flex;
              align-items: center;
              margin-bottom: 5px;
          }

        &.gray {
          color: #757575;
        }
      }
    }
  }

  .demo {
    .panel {
      // min-height: 85px;
      // margin-bottom: 16px;
      height: 50px;
      margin-bottom: 36px;
      .icon {
        margin-bottom: 10px;
      }

      .demo_title {
        .FontLatoBlack;
        .fs(24px, 28.8px);
        color: #191919;
        margin-bottom: 5px;
      }
    }
  }

  .plan_features {
    .FontLatoRegular;
    .fs(12px, 20px);
    color:#666666;
    margin-bottom: 24px;

    .features_desc {
      margin-bottom: 12px;
      .FontLatoRegular;
      .fs(12px, 21px);
      color:#191919;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .features_list {
      padding-left: 0 !important;

      .item {
        position: relative;
        margin-bottom: 5px;
        display:flex;
        gap:8px;

        &::before {
          content: '';
          position: relative;
          display:block;
          background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMTM0NikiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgZmlsbD0iI0QwRTBGMiIvPgo8cGF0aCBkPSJNNi42NjY5OSAxMC40MTY3TDguOTUxNjEgMTMuMDE1NEM5LjA5NDA0IDEzLjE3NzQgOS4zNTA1MSAxMy4xNjM1IDkuNDc0NjEgMTIuOTg3MUwxMy4zMzM3IDcuNSIgc3Ryb2tlPSIjMTU2NUMwIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMTM0NiI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjYuNjY2NjciIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==);
          min-width:20px;
          min-height: 20px;
        }
      }
    }
  }

  .locked_view {
    position: absolute;
    bottom: -7px;
    left: 50%;
    transform: translateX(-50%);
    height: 52px;
    width: calc(100% + 16px);
    display: flex;
    align-items: center;
    background-color: #eee;
    border-radius: 2px;
    padding: 0 8px;

    .lock_desc {
      .FontLatoRegular;
      .fs(14px, 20px);
      color: @textColor;
      padding-left: 10px;
    }
  }

  .about_plan_link {
    cursor: pointer;
    display: flex;
    align-items: flex-start;
    height: 20px;
    gap:8px;
    &:hover {
      gap:12px;
    }
    &.link {
      .FontLatoBold;
      .fs(12px, 16px);
      color: #1565C0;
      text-decoration: none;
      white-space: nowrap;
      border-bottom: 1px solid transparent;

    }
    & svg {
      min-width: 20px;
      margin-top:2px;
    }
  }

  .current_plan_sticker {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    .FontLatoBold;
    .fs(14px, 24px);
    border-radius: 4px;
    color: #232323;
    padding: 4px 0;
    cursor: pointer;
    background-color: #F1F5FB;

    .sticker_text {
      padding-left: 4px;
      cursor: default;
    }
  }

  &.page_item {
    min-width: calc(25% - 16px);
    width: calc(25% - 16px);
    margin-right: 8px;

    &:last-child {
      margin-right: 0;
    }

    .title {
      .plan-name {
        .FontLatoBlack;
        .fs(20px, 30px);
        color: @titleHeadColor;
      }
    }

    .about_plan_link {
      a {
        color: #424242 !important;
      }
    }
  }

  &.enterprise {
    background: linear-gradient(180deg, var(--color-mainpalette-MB600-mainblue, #1565C0) 0%, var(--color-extendedpalette-mainblue-MB300, #08284D) 81.3%);
    color: #fff;

    .title {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .plan_name {
        color: #fff;
      }

      .chip {
        .FontLatoRegular;
        font-size: 12px;
        line-height: 16wpx;
        color: #D0E0F2;
        padding: 8px 12px;
        border-radius: 24px;
        background: #08284D;
      }
    }

    .description {
      color: #fff;
    }

    .price {
      .info {
        .currency {
          .code,
          .value,
          .label {
            color: #fff;
          }

          .value.old_price {
            position: relative;
            .FontLatoRegular;
            color: fade(#fff, 60%);

            &::after {
              content: '';
              position: absolute;
              top: 50%;
              left: 0;
              height: 1px;
              width: 100%;
              background: fade(#fff, 60%);
            }
          }
        }
      }

      .btn {
        background-color: #fff;
        color: #1565C0;

        &:hover {
          background-color: #E7EFF8;
        }

        &.monthly_btn {
          font-size: 13px;
        }

          &.monthly_btn_disabled {
              opacity : 0.5
          }
      }
    }

    .plan_features {
      .features_desc {
        color: #fff;
      }

      .features_list {
        .item {
          color: #fff;

          &::before {
            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMzkzOCkiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgZmlsbD0iIzE1NjVDMCIvPgo8cGF0aCBkPSJNNi42NjYwMiAxMC40MTY3TDguOTUwNjMgMTMuMDE1NEM5LjA5MzA2IDEzLjE3NzQgOS4zNDk1MyAxMy4xNjM1IDkuNDczNjMgMTIuOTg3MUwxMy4zMzI3IDcuNSIgc3Ryb2tlPSIjRDBFMEYyIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMzkzOCI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjYuNjY2NjciIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==');
          }
        }
      }
    }

    .about_plan_link {
      color: #fff;

      svg path {
        stroke: #fff;
      }
    }

    &.disabled {
      background: linear-gradient(180deg, var(--color-mainpalette-MB600-mainblue, rgba(21, 101, 192, 0.60)) 0%, var(--color-extendedpalette-mainblue-MB300, rgba(8, 40, 77, 0.60)) 81.3%);

      .features_list {
        .item {
          &::before {
            background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzFfMzgzMikiPgo8cmVjdCB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHJ4PSIxMCIgZmlsbD0iIzczQTNEOSIvPgo8cGF0aCBkPSJNNi42NjYwMiAxMC40MTY3TDguOTUwNjMgMTMuMDE1NEM5LjA5MzA2IDEzLjE3NzQgOS4zNDk1MyAxMy4xNjM1IDkuNDczNjMgMTIuOTg3MUwxMy4zMzI3IDcuNSIgc3Ryb2tlPSIjRDBFMEYyIiBzdHJva2Utd2lkdGg9IjEuMjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8L2c+CjxkZWZzPgo8Y2xpcFBhdGggaWQ9ImNsaXAwXzFfMzgzMiI+CjxyZWN0IHdpZHRoPSIyMCIgaGVpZ2h0PSIyMCIgcng9IjYuNjY2NjciIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==');
          }
        }
      }
    }
  }
}
</style>
<style lang="less">
.people-tooltip {
  .webix_view {
    cursor: pointer;
  }
}

.current-plan-sticker {
  .webix_view {
    .webix_template {
      svg {
        path {
          fill: #232323
        }
      }
    }
  }
}
</style>
